import { Injectable } from '@angular/core';
import { IAMTenant } from './model/iam-toggle.model';

@Injectable({
  providedIn: 'root',
})
export class IamToggleService {
  static readonly TOGGLE_STORAGE_KEY = 'markant-platform-iam-toggle';

  isActive(tenant: IAMTenant): boolean {
    const _tenant: string | null = sessionStorage.getItem(IamToggleService.TOGGLE_STORAGE_KEY);
    return tenant === (_tenant ?? IAMTenant.PLATFORM);
  }

  updateTenant(tenant: IAMTenant): void {
    sessionStorage.setItem(IamToggleService.TOGGLE_STORAGE_KEY, tenant);
  }
}
